// extracted by mini-css-extract-plugin
export default {"productBorder":"ProductList_productBorder__VJ-pU"};